var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1254 5.87558C14.4508 6.20101 14.4508 6.72865 14.1254 7.05409L7.05431 14.1252C6.72887 14.4506 6.20123 14.4506 5.87579 14.1252C5.55036 13.7997 5.55036 13.2721 5.87579 12.9466L12.9469 5.87558C13.2723 5.55014 13.7999 5.55014 14.1254 5.87558Z",
    fill: "#94A3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1252 14.1252C13.7998 14.4506 13.2722 14.4506 12.9467 14.1252L5.87567 7.05412C5.55023 6.72869 5.55023 6.20105 5.87567 5.87561C6.20111 5.55017 6.72874 5.55017 7.05418 5.87561L14.1252 12.9467C14.4507 13.2721 14.4507 13.7998 14.1252 14.1252Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modalCloseIcon.094199fb30928e8b526f18c17ea35c79.svg";
export { ForwardRef as ReactComponent };